import {
  Link,
  TableCellText,
} from "@ceridianhcm/components";
import StandAloneContext from "../../common/components/context/StandAloneContext";
import { SetStateAction, useContext } from "react";
import { FileType, IsProduction, StandAloneActions, Status } from "../../models/StandAloneData";
import { FormatFullDate } from "../../common/formatting";

export const ColumnsDefinitions = (setConfirmModal: { (value: SetStateAction<boolean>): void; (arg0: boolean): void; }) => {  
  const { state, dispatch } = useContext(StandAloneContext);
  
  const onClickHandler = (rowData: any) => {
    dispatch({
       type: StandAloneActions.SET_SELECTED_FILE,
       payload: { 
        ...state, 
        importId: rowData.importId,
        fileName: rowData.fileName,
        fileType: rowData.fileType,
        status: rowData.status
      },
    });
     setConfirmModal(true);
  };
  
  return [
    {
      field: "companyName",
      label: "Company Name",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={cellContext.rowData.companyName}>
            {cellContext.rowData.companyName}
          </div>
        </TableCellText>
      ),
    },
    {
      field: "companyId",
      label: "Company ID",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={cellContext.rowData.companyId}>
           {cellContext.rowData.companyId?.slice(1)}
          </div>
        </TableCellText>
      ),
    },
    {
      field: "fileName",
      label: "File Name",
      cellTemplate: (cell: any) => {
        return (
          <Link
            id={`name-${cell.rowData.fileName}`}
            onClick={() => onClickHandler(cell.rowData)}
            variant="neutral"
            testId={`name-${cell.rowData.fileName}`}
          >
            <div title={cell.rowData.fileName}>{cell.rowData.fileName}</div>
          </Link>
        );
      },
    },
    {
      field: "fileType",
      label: "File Type",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={FileType[cellContext.rowData.fileType]}>
            {FileType[cellContext.rowData.fileType]}
          </div>
        </TableCellText>
      ),
    },
    {
      field: "isProduction",
      label: "Prod/Test",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={IsProduction[cellContext.rowData.isProduction]}>
            {IsProduction[cellContext.rowData.isProduction]}
          </div>
        </TableCellText>
      ),
    },
    {
      field: "status",
      label: "Status",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={Status[cellContext.rowData.status]}>
            {Status[cellContext.rowData.status]}
          </div>
        </TableCellText>
      ),
    },
    {
      field: "createdOn",
      label: "Created Date",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={FormatFullDate(cellContext.rowData.createdOn)}>
            {FormatFullDate(cellContext.rowData.createdOn)}
          </div>
        </TableCellText>
      ),
    }   
  ];
};
